// Contact store module - handles contact form submissions
const API_BASE = process.env.VUE_APP_API_BASE;
const API_USUARIOS = `${API_BASE}/ajax/usuarios.php`;

export default {
  namespaced: true,

  state: {
    submissions: [],
    loading: false,
    error: null,
    successMessage: null,
  },

  getters: {
    getAllContactos: (state) => state.submissions,
    getUnreadSubmissions: (state) => {
      return state.submissions.filter((sub) => !sub.read)
    },
    isLoading: (state) => state.loading,
    getError: (state) => state.error,
    getSuccessMessage: (state) => state.successMessage,
  },

  mutations: {
    SET_SUBMISSIONS(state, contactos) {
      state.submissions = contactos
    },
    ADD_SUBMISSION(state, submission) {
      state.submissions.unshift(submission)
    },
    MARK_SUBMISSION_READ(state, submissionId) {
      const submission = state.submissions.find((s) => s.id === submissionId)
      if (submission) {
        submission.read = true
      }
    },
    DELETE_SUBMISSION(state, submissionId) {
      state.submissions = state.submissions.filter((s) => s.id !== submissionId)
    },
    SET_LOADING(state, loading) {
      state.loading = loading
    },
    SET_ERROR(state, error) {
      state.error = error
    },
    SET_SUCCESS_MESSAGE(state, message) {
      state.successMessage = message
    },
    CLEAR_MESSAGES(state) {
      state.error = null
      state.successMessage = null
    },
  },

  actions: {
    async fetchSubmissions({ commit }) {
      commit("SET_LOADING", true)
      commit("SET_ERROR", null)
      try {
        const response = await fetch(`${API_USUARIOS}?action=getAll`)
        const data = await response.json()

        if (data.success) {
          commit("SET_SUBMISSIONS", data.contactos)
          return { success: true, count: data.contactos?.length || 0 }
        } else {
          commit("SET_ERROR", data.message || "Error al cargar mensajes")
          return { success: false, message: data.message }
        }
      } catch (error) {
        console.error("Error fetching submissions:", error)
        commit("SET_ERROR", "Error de conexión al cargar mensajes")
      } finally {
        commit("SET_LOADING", false)
      }
    },

    async submitContactForm({ commit }, contactData) {
      commit("SET_LOADING", true)
      commit("CLEAR_MESSAGES")
      try {
        const response = await fetch(`${API_USUARIOS}?action=add`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(contactData),
        })
        const data = await response.json()

        if (data.success) {
          commit("SET_SUCCESS_MESSAGE", "Mensaje enviado correctamente. Nos pondremos en contacto pronto.")
          return { success: true }
        } else {
          commit("SET_ERROR", data.message || "Error al enviar el mensaje")
          return { success: false, message: data.message }
        }
      } catch (error) {
        console.error("Error submitting contact form:", error)
        commit("SET_ERROR", "Error de conexión al enviar el mensaje")
        return { success: false, message: "Error de conexión" }
      } finally {
        commit("SET_LOADING", false)
      }
    },

    async markSubmissionAsRead({ commit }, submissionId) {
      try {
        const response = await fetch(`YOUR_PHP_API_URL/admin/contact-submissions/${submissionId}/read`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        })
        const data = await response.json()

        if (data.success) {
          commit("MARK_SUBMISSION_READ", submissionId)
        }
      } catch (error) {
        console.error("[v0] Error marking submission as read:", error)
      }
    },

    // Cambiar vigencia
    async toggleVigente({ dispatch }, { id, vigente }) {
      try {
        const res = await fetch(`${API_USUARIOS}?action=setVigente`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id, vigente }),
        })
        const data = await res.json()
        if (data.success) {
          await dispatch("fetchSubmissions")
        }
        return data
      } catch (err) {
        console.error("Error toggleVigente:", err)
        return { success: false }
      }
    },

    async deleteSubmission({ commit }, submissionId) {
      try {
        const response = await fetch(`${API_USUARIOS}?action=delete`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        })
        const data = await response.json()

        if (data.success) {
          commit("DELETE_SUBMISSION", submissionId)
          return { success: true }
        } else {
          return { success: false, message: data.message }
        }
      } catch (error) {
        console.error("[v0] Error deleting submission:", error)
        return { success: false, message: "Error de conexión" }
      }
    },

    clearMessages({ commit }) {
      commit("CLEAR_MESSAGES")
    },
  },
}
